import { AnyAction } from 'redux'
import { EventDefinition } from 'redux-beacon'
import optimizely from './optimizely'

import { FullStackTrackable } from '@chegg/optimizely-sdk'
import { AuthSuccessGrant } from '@src/utils/cheggAuth'
import { isExpertCheckPage } from '@src/utils/routes'
import { RouterState } from 'connected-react-router'

export const FREE_TRIAL_START = 'free-trial-start'
export const PAPER_UPLOADED = 'paper-uploaded'
export const ACCOUNT_CREATED = 'account-created'
export const EXPERT_CHECK_SUBMISSION = 'expert-check-submission'
export const EXPERT_CHECK_PAGEVIEW = 'expert-check-pageview'

const getUserId = () => {
  return optimizely?.user?.id
}

const createEvent = (action: AnyAction, eventKey: string): FullStackTrackable => ({
  eventKey,
  overrideUserId: getUserId() as string,
  eventTags: { action: action.type },
})

export const freeTrialStartEvent: EventDefinition = (action: AnyAction) =>
  createEvent(action, FREE_TRIAL_START)

export const paperUploadedEvent: EventDefinition = (action: AnyAction) =>
  createEvent(action, PAPER_UPLOADED)

export const accountCreatedEvent: EventDefinition = (action: AnyAction) => {
  const payload = action.payload as AuthSuccessGrant

  if (!payload || payload.auth_type !== 'signup') {
    return {}
  }

  return createEvent(action, ACCOUNT_CREATED)
}

export const expertCheckSubmissionEvent: EventDefinition = (action: AnyAction) => {
  return createEvent(action, EXPERT_CHECK_SUBMISSION)
}

export const locationChangeEvent: EventDefinition = (action: AnyAction) => {
  const location = (action.payload as RouterState).location
  if (location) {
    const { pathname } = location
    switch (true) {
      case isExpertCheckPage(pathname):
        return createEvent(action, EXPERT_CHECK_PAGEVIEW)
      default:
        return {}
    }
  }
  return {}
}



// WEBPACK FOOTER //
// ./src/state/optimizely/events.ts